import React from "react";
import { Wrapper, Label, ValueRow, Value } from "./DetailField.styles";
import type { DetailFieldProps } from "./DetailField.types";

const isPrimitiveValue = (value: React.ReactNode): value is string | number =>
  typeof value === "string" || typeof value === "number";

/**
 * Two-line label/value pair used by the connection-info and health cards
 * (UI-4) and the field hover card's stat tiles (`size="sm"`). Stateless —
 * renders whatever `value` is, wrapping primitive values in a styled `<Value>`
 * for ellipsis truncation (full text in `title`) and forwarding ReactNodes
 * unchanged so callers can embed status pills or masked credentials.
 */
export const DetailField: React.FC<DetailFieldProps> = ({
  label,
  value,
  trailing,
  boxed = false,
  size = "md",
  className,
  testId,
}) => (
  <Wrapper className={className} data-testid={testId} $boxed={boxed} $size={size}>
    <Label $size={size}>{label}</Label>
    <ValueRow>
      {isPrimitiveValue(value) ? (
        <Value $size={size} title={String(value)}>
          {value}
        </Value>
      ) : (
        value
      )}
      {trailing}
    </ValueRow>
  </Wrapper>
);

export default DetailField;
